import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M7.99967 1.33333C6.34282 1.33333 4.99967 2.67647 4.99967 4.33333C4.99967 5.99018 6.34282 7.33333 7.99967 7.33333C9.65653 7.33333 10.9997 5.99018 10.9997 4.33333C10.9997 2.67647 9.65653 1.33333 7.99967 1.33333Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M8.00066 8C5.44606 8 3.49091 9.53081 2.69704 11.6773C2.47009 12.291 2.62547 12.8959 2.98624 13.3258C3.33782 13.7448 3.88056 14 4.46522 14H11.5361C12.1208 14 12.6635 13.7448 13.0151 13.3258C13.3759 12.8959 13.5312 12.291 13.3043 11.6773C12.5104 9.53081 10.5553 8 8.00066 8Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }